<template>
  <Question
    :back-route="backRoute"
    :next-button-theme="nextButtonTheme"
    :subtitle="$t('kyc.titles.identity')"
    :title="$t('kyc.questions.job')"
    :progress-ratio="1/9/4"
    @next="next"
  >
    <BaseSection>
      <BaseInputGroup
        v-model="job"
        :label="$t('kyc.labels.job')"
        autocomplete="off"
        class="mb-4"
      />
    </BaseSection>
  </Question>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import kyc from '../../mixins/kyc';
import Question from './Question.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseInputGroup from '../../components/BaseInputGroup.vue';

export default {
  name: 'Job',
  components: {
    Question,
    BaseSection,
    BaseTitleGroup,
    BaseInputGroup,
  },
  mixins: [kyc],
  computed: {
    ...mapFields('kyc', ['form.attributes.job']),
    nextButtonTheme() {
      if (this.job) {
        return 'primary';
      }
      return 'disabled';
    },
    backRoute() {
      if (this.form && this.form.attributes.introductionValidatedAt) {
        return '/opportunities';
      }
      return '/kyc/introduction';
    },
  },
  methods: {
    goBack() {
      this.$router.push('/opportunities');
    },
    next() {
      this.update();
      this.$router.push('/kyc/tax-residence');
    },
  },
};
</script>
